'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'duck';
var width = 512;
var height = 512;
var aliases = [129414];
var unicode = 'f6d8';
var svgPathData = 'M368 209.3l0 63.5 10 9.5c18.5 17.5 30 42.3 30 69.7 0 53-43 96-96 96l-120 0c-87.4 0-158.5-70.1-160-157.2 34.4 14.7 52.3 22.4 53.7 23l10.9-3 165-46.2 26.3-7.4 0-37.3-15.8-11.8c-19.6-14.6-32.2-37.9-32.2-64.2 0-44.2 35.8-80 80-80s80 35.8 80 80c0 21.8-8.7 41.5-22.9 56l-9.1 9.3zM88 280l-56-24-32 0 0 32C0 394 86 480 192 480l120 0c70.7 0 128-57.3 128-128 0-36.6-15.4-69.6-40-93l0-19 16 0c53 0 96-43 96-96l0-29.1c-9.1 1.1-26.9 3.4-53.4 6.7-9.6 1.2-19.3 1.1-28.9-.1-10.5-51-55.6-89.4-109.7-89.4-61.9 0-112 50.1-112 112 0 23.6 7.3 45.6 19.8 63.6 6.9 10 15.5 18.9 25.2 26.2-9.1 2.5-64.1 18-165 46.2zM431.6 153.8c10.3 .9 20.7 .8 31-.5l17-2.1C476 183.1 448.9 208 416 208l-4.1 0c10.9-15.6 17.9-34.2 19.7-54.2zM360 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM293.5 307.5c-4.5 33.5-29.9 63.3-66.7 72.5-30.1 7.5-60-.8-80.7-19.1l-21.2 23.9c28.5 25.3 69.3 36.3 109.7 26.2 49.3-12.3 84.5-52.6 90.7-99.3l-31.7-4.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDuck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;